import { monthName } from '../../../../commons/util/date';

const FULL_MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
];

function ordinalSuffix (day) {
    if (day % 10 === 1 && day % 100 !== 11) return 'st';
    if (day % 10 === 2 && day % 100 !== 12) return 'nd';
    if (day % 10 === 3 && day % 100 !== 13) return 'rd';
    return 'th';
}

// The API sends midnight-UTC timestamps representing a calendar date (e.g.
// "2027-06-30T00:00:00Z" means "30 Jun 2027"), so both formatters read UTC
// fields — local getters would shift the date by a day in timezones behind UTC.

// "July 31st, 2026" — used for cancellation messaging.
export function formatOrdinalPlanDate (isoDate) {
    const d = new Date(isoDate);
    const day = d.getUTCDate();
    return `${FULL_MONTHS[d.getUTCMonth()]} ${day}${ordinalSuffix(day)}, ${d.getUTCFullYear()}`;
}

// "1 Jun 2026" — used for the change-scheduled card notice. monthName() takes
// a 0-indexed month (unlike readable()'s dead-code "+1" caller in date.js).
export function formatShortPlanDate (isoDate) {
    const d = new Date(isoDate);
    return `${d.getUTCDate()} ${monthName(d.getUTCMonth())} ${d.getUTCFullYear()}`;
}

// "July 2026" — current usage-period label shown next to "Transaction usage".
// Uses local time (not UTC) since this represents "now", not a parsed API date.
export function formatCurrentMonthYear (date = new Date()) {
    return `${FULL_MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}

export function getPlanScheduleNotice (plan) {
    if (!plan) return null;
    if (plan.status === 'pending_cancellation') {
        return {
            tone: 'cancellation',
            date: formatOrdinalPlanDate(plan.cancellationScheduledAt),
        };
    }
    if (plan.status === 'pending_upgrade' || plan.status === 'pending_downgrade') {
        return {
            tone: plan.status === 'pending_upgrade' ? 'upgrade' : 'downgrade',
            nextPlanName: plan.nextPlanName,
            date: formatShortPlanDate(plan.nextRenewalDate),
        };
    }
    return null;
}
